
import { defineComponent, PropType, ref, Ref } from "vue";
import { formatDateTime } from "../../mixins";
import { Notification } from "../../../../../domain/entities/notifications/notification";
import TUIViewer from "../TUIViewer.vue";

const __default__ = defineComponent({
  name: "NotificationItem",
  components: { TUIViewer },
  props: {
    notification: {
      type: Object as PropType<Notification>,
      required: true
    }
  },
  methods: { formatDateTime },
  setup(props) {
    const image: Ref<string> = ref(`url(${props.notification.image})`);
    return { image };
  }
});

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "f81f9e7a": (_ctx.image)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__